export default __webpack_public_path__ + "static/agile-development-orangeloop-9c562e3fcdbb609f42094bd919d0f320.jpg";